import * as _ from 'lodash';

export default {
    state: {
        message: null
    },

    mutations: {
        setErrorMessage: (state, message) => {
            state.message = message;
        }
    },

    actions: {
        handleError: function (context, err) {
            var msg = "";
            if (err.response && err.response.status === 400) {
                if (Array.isArray(err.response.data)) {
                    _.forEach(err.response.data, (valError) => {
                        msg += valError.error_message + "<br/>";
                    });
                } 
                if (err.response.data.errors && Array.isArray(err.response.data.errors)) {
                    _.forEach(err.response.data.errors, (valError) => {
                        msg += valError.error_message + "<br/>";
                    });
                } else {
                    msg = err.response.data;
                }
                context.commit('setErrorMessage', msg);
            } else if (err.response && err.response.status === 500 && err.response.data && err.response.data.error_message) {
                msg = err.message + "<br/>" + err.response.data.error_message;
                context.commit('setErrorMessage', msg);
            } else if (err.message) {
                console.log(err);
                context.commit('setErrorMessage', err.message);
            } else {
                console.log(err);
                context.commit('setErrorMessage', err);
            }
        },
        clearError: function (context) {
            context.commit('setErrorMessage', null);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/error/error.module.js